module.exports = __webpack_public_path__ + "static/media/visual.c0c9f4b1.jpg";